export enum SourcingType {
  Private = 0,
  Internal = 1,
  External = 2,
  Active = 3,
  Passive = 4,
}
